import { useEffect } from "react";
import Input from "../../../../../components/input/Input";
import { useWebsite } from "../Context/WebSiteContext";

const FooterSite = ({ control, errors, setValue, getValues }) => {
  const { formData, updateFormData } = useWebsite();

  useEffect(() => {
    if (formData.footer) {
      Object.entries(formData.footer).forEach(([key, value]) => {
        setValue(key, value);
      });
    }
  }, [setValue, formData.footer]);

  const handleChange = (name, value) => {
    setValue(name, value);
    updateFormData("footer", name, value);
  };

  return (
    <div className="form-grid">
      <Input
        type="text"
        control={control}
        errors={errors}
        label="Endereço completo"
        name="endereco"
        className="form-control"
        rules={{ required: "Campo obrigatório" }}
        onChange={(e) => handleChange("endereco", e.target.value)}
      />

      <Input
        type="tel"
        control={control}
        errors={errors}
        label="Telefone"
        name="telefone"
        className="form-control"
        rules={{
          required: "Campo obrigatório",
          pattern: {
            value: /^\d+$/,
            message: "Apenas números",
          },
        }}
        onChange={(e) => handleChange("telefone", e.target.value)}
      />

      <Input
        type="email"
        control={control}
        errors={errors}
        label="E-mail"
        name="email"
        className="form-control"
        rules={{
          required: "Campo obrigatório",
          pattern: {
            value: /^\S+@\S+$/i,
            message: "E-mail inválido",
          },
        }}
        onChange={(e) => handleChange("email", e.target.value)}
      />

      <Input
        control={control}
        errors={errors}
        label="Seu usuario no facebook"
        name="facebook"
        className="form-control"
        onChange={(e) => handleChange("facebook", e.target.value)}
      />
    </div>
  );
};

export default FooterSite;
